import axios from 'axios'

export default axios.create({
    baseURL: 'https://lpnsecureapi.lpn.co.th/api/'
})